import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpRequestService} from '../services/http-request/http-request.service';
import {tap} from 'rxjs/operators';
import {v4 as uuid} from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class TickHttpRequestInterceptorService implements HttpInterceptor {
  constructor(private httpRequestService: HttpRequestService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const httpRequest = {id: uuid(), method: req.method};
    this.httpRequestService.startRequest(httpRequest);
    return next.handle(req).pipe(tap(() => this.httpRequestService.endRequest(httpRequest)));
  }
}
